
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { useProductDocuments } from "@/hooks/useProductDocuments";
import { useLanguage } from "@/contexts/LanguageContext";
import { ProductButtons } from "./ProductButtons";

interface ProductInfoProps {
  name: string;
  description: string;
  id: string;
}

export const ProductInfo = ({ name, description, id }: ProductInfoProps) => {
  const { getDocumentLink } = useProductDocuments(id);
  const { t } = useLanguage();
  
  const getBriefDescription = (text: string) => {
    const firstParagraph = text.split('\n\n')[0];
    return firstParagraph.length > 150 
      ? firstParagraph.substring(0, 150) + '...' 
      : firstParagraph;
  };

  const briefDescription = getBriefDescription(description);
  const documentLink = getDocumentLink();

  const formattedName = t(name).split('\n').map((line, index) => (
    <span key={index} className={index > 0 ? "block text-lg font-medium" : ""}>
      {line}
    </span>
  ));

  // No-op function since we're removing pricing functionality
  const showPrice = () => {
    // Pricing functionality removed
  };

  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold tracking-tight">
        {formattedName}
      </h1>
      <p className="text-lg text-muted-foreground">{t(briefDescription)}</p>
      
      <ProductButtons 
        id={id}
        priceData={null}
        onShowPrice={showPrice}
      />
      
      <div className="mt-6 pt-4 border-t text-sm text-muted-foreground">
        <Link to="/privacy" className="inline-flex items-center hover:text-foreground">
          <Shield className="mr-1 h-3 w-3" />
          {t('privacy.policy')}
        </Link>
      </div>
    </div>
  );
};
